shadow$provide[445] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform vec4 sliceOffset;

vec4 getSliceOffset(vec4 xyzw) {
  return xyzw + sliceOffset;
}
`;

};